import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import confirmIcon from '../../asset/icon/confirm.png';
import { useTempAlertStore } from '../../shared/store/portal/tempAlertStore';
import { slideInFromBottom, slideInFromRight } from '../../shared/component/Animation';
import { paperTextureAlert } from '../../shared/component/paperTexture';
import { TempAlertType } from '../../shared/enum/EnumRepository';
import LogoWave from '../../shared/component/LogoWave';
import theme from '../../shared/theme';


const TempAlertComp: React.FC = () => {
  const { tempAlert, clearTempAlert } = useTempAlertStore();
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (tempAlert?.duration) {
      const timer = setTimeout(() => {
        setIsClosing(true);
        setTimeout(() => {
          // callBack 함수가 있으면 실행 ()
          if (tempAlert.callBack) {
            tempAlert.callBack();
          }
          clearTempAlert();
        }, 300);
      }, tempAlert.duration);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [tempAlert, clearTempAlert]);

  if (tempAlert === null) return null;

  const renderTempAlertContent = () => {
    if (tempAlert.type === TempAlertType.PAYMENT_PROCESSING) {
      return (
        <TempAlertCenterContent
          $isClosing={isClosing}>
          <LogoWave size={'small'} />
          <CenterContent>{tempAlert.content}</CenterContent>
        </TempAlertCenterContent>
      );
    }
    if (tempAlert.type === TempAlertType.PW_NOT_SET || tempAlert.type === TempAlertType.UNAUTHORIZED_ACCESS) {
      return (
        <TempAlertCenterTopContent
          $isClosing={isClosing}
          onClick={tempAlert.onClick ? tempAlert.onClick : (() => {clearTempAlert()})}>
          <Content>{tempAlert.content}</Content>
        </TempAlertCenterTopContent>
      );
    }
    return (
      <TempAlertContent
        $isClosing={isClosing}
        onClick={tempAlert.onClick ? tempAlert.onClick : (() => {clearTempAlert()})}>
        <ConfirmIconWrapper>
          <ConfirmIcon $backgroundImg={confirmIcon} />
        </ConfirmIconWrapper>
        <Content>{tempAlert.content}</Content>
      </TempAlertContent>
    );
  }
  return (
    <>
      {renderTempAlertContent()}
    </>
  );
};


// 공통 기본 스타일
const BaseTempAlertContent = styled.div<{ $isClosing: boolean }>`
  position: fixed;
  display: flex;
  align-items: center;
  gap: 1vw;
  width: fit-content;
  height: fit-content;
  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  ${paperTextureAlert}
  z-index: 7777;
`;

// 중앙 위치
const TempAlertCenterContent = styled(BaseTempAlertContent)`
  left: 50%;
  top: 50%;
  display: flex;
  align-items: center;
  gap: 12px;
  transform: translate(-50%, -50%);
  min-width: 250px;
  height: clamp(50px, 50px, 50px);
  padding: 12px clamp(14px, 2vw, 20px);
`;

// 우측 상단 위치
const TempAlertCenterTopContent = styled(BaseTempAlertContent)`
  right: 2vw;
  top: 24px;
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateX(100%)'
      : 'translateX(0)'
  };
  width: clamp(210px, 20vw, 250px);
  height: clamp(38px, 8vw, 40px);
  padding: 12px clamp(14px, 2vw, 20px);
  border-left: 10px solid ${theme.colors.color_Gray_01};
  cursor: pointer;
  transition: all 0.4s ease-out;
  ${slideInFromRight}
`;

// 우측 하단 위치
const TempAlertContent = styled(BaseTempAlertContent)`
  right: 2vw;
  bottom: 24px;
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateY(100%)'
      : 'translateY(0)'
  };
  min-width: 200px;
  max-width: 260px;
  height: clamp(44px, 50px, 50px);

  padding: 12px clamp(10px, 2vw, 14px);
  transition: all 0.4s ease-out;
  ${slideInFromBottom}
`;

const Content = styled.div`
  ${({ theme }) => theme.typography.Body_03_2};
`;

const CenterContent = styled.div`
    ${({ theme }) => theme.typography.Body_02_1};
  `;

const ConfirmIconWrapper = styled.div`
  padding: 8px;
`;

const ConfirmIcon = styled.div<{ $backgroundImg: string }>`
  width: clamp(14px, 1.5vw, 16px);
  height: clamp(14px, 1.5vw, 16px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
`;

export default TempAlertComp;